import type React from 'react';

import { InstantSearch } from 'react-instantsearch';

import { MaintenanceContainer } from '../components/MaintenanceContainer';
import { PageBody } from '../components/PageBody';
import { PageMeta } from '../components/PageMeta';
import { ResetFiltersOnSamePageNavigation } from '../components/ResetFiltersOnSamePageNavigation';

import { useLayout } from './hooks/useLayout';
import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();

	const {
		data: { searchClient, routing, instantSearchIndexName, isUnderMaintenance },
	} = useLayout();

	if (isUnderMaintenance) {
		return <MaintenanceContainer />;
	}

	return (
		<>
			<PageMeta />
			<InstantSearch
				indexName={instantSearchIndexName}
				searchClient={searchClient}
				routing={routing}
				future={{
					// This allow us to preserve the state of the widgets when the component is unmounted
					// eg: when the new modal is closed
					preserveSharedStateOnUnmount: true,
				}}
			>
				<PageBody />
				<ResetFiltersOnSamePageNavigation />
			</InstantSearch>
		</>
	);
};
